import { render, staticRenderFns } from "./proSitForm.vue?vue&type=template&id=71823f12&"
import script from "./proSitForm.vue?vue&type=script&lang=js&"
export * from "./proSitForm.vue?vue&type=script&lang=js&"
import style0 from "./proSitForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports